<template>
  <div class="plan" v-pageBuried data-page-buried="BG_JIHUALIEBIAO">
    <div v-if="customPlan.length" class="wrapper">
      <AppNavBar
        :title="title"
        :placeholder="placeholder"
        :options="haveCustomOptions"
        :z-index="999"
      >
        <!--  <div slot="right" v-if="customPlan.length && config && config.expert_incoming_line">
                    <img class="consult-icon" @click="bindTopConsult" :src="config.expert_incoming_line.head_img"
                    v-clickBuried  data-click-buried="CLICK_LIEBIAODINGLAN_JINXIAN"  v-buried  data-buried="BG_LIEBIAODINGLAN_JINXIAN"
                        alt="">
                </div> -->
      </AppNavBar>
      <van-tabs
        class="my-tabs"
        v-model="active"
        v-if="customPlan.length"
        @rendered="bindRendered"
      >
        <van-tab title="营养师精选"></van-tab>
        <van-tab title="自定义"></van-tab>
      </van-tabs>
      <div class="plan-content">
        <div class="plan-custom" v-if="showCustom" v-show="active == 1">
          <div class="plan-scroll">
            <div class="custom-plan" v-if="customPlan.length">
              <ActivityBar
                class="activity-bar"
                :data="activityInfo"
                v-if="active == 1"
              />
              <div
                class="custom-list"
                v-pageBuried
                data-page-buried="BG_JIHUALIEBIAO_ZIDINGYI"
              >
                <CustomPlanItem
                  class="custom-item"
                  v-for="(item, index) in customPlan"
                  :key="index"
                  :data="item"
                  @delete="bindDeleteCustomPlan"
                />
              </div>
            </div>
          </div>
          <div class="add-content">
            <div
              class="add-btn"
              @click="bindAddPlan"
              v-clickBuried
              data-click-buried="CLICK_JIHUALIEBIAO_XINZENG"
              ><span class="iconfont icon-jiahao"></span>自定义计划</div
            >
          </div>
        </div>
        <div class="plan-recommend" v-show="active == 0">
          <div v-if="recommendPlan.length">
            <div class="recommend-plan">
              <van-list
                v-model="loading"
                :finished="finished"
                finished-text=""
                @load="getTemplatePlanList"
              >
                <div class="recommend-plan-container">
                  <ActivityBar
                    class="activity-bar"
                    :data="activityInfo"
                    v-if="active == 0"
                  />
                  <div
                    class="recommend-plan-list"
                    v-pageBuried
                    data-page-buried="BG_JIHUALIEBIAO_JINGXUAN"
                  >
                    <TemplatePlanItem
                      class="recommend-item"
                      v-for="(item, index) in recommendPlan"
                      :key="index"
                      :data="item"
                    />
                  </div>
                </div>
              </van-list>
              <div class="not-more" v-if="finished"
                >- 更多明星同款补剂计划敬请期待 -</div
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="" v-else>
      <AppNavBar
        :title="title"
        :placeholder="placeholder"
        :options="options"
        :z-index="999"
      >
      </AppNavBar>
      <div class="plan-recommend">
        <div v-if="recommendPlan.length">
          <div class="recommend-plan">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text=""
              @load="getTemplatePlanList"
            >
              <div>
                <div class="not-custom-plan" v-if="!customPlan.length">
                  <div
                    class="add-btn"
                    @click="bindAddPlan"
                    v-clickBuried
                    data-click-buried="CLICK_JIHUALIEBIAO_XINZENG"
                    ><span>创建自定义计划</span
                    ><span class="iconfont icon-jiahao"></span>
                  </div>
                  <!-- <div class="consult" v-if="config && config.index_incoming_line" v-buried data-buried="BG_JINGXUANLIEBIAO_JINXIAN">
                                        <img class="c-avatar" :src="config.index_incoming_line.image" alt="">
                                        <div class="c-text">{{ config.index_incoming_line.title }}</div>
                                        <div class="c-jump" @click="bindConsult" v-clickBuried
                            data-click-buried="CLICK_JINGXUANLIEBIAO_JINXIAN" >
                                            {{ config.index_incoming_line.sub_title }}<span
                                                class="iconfont icon-you"></span>
                                        </div>
                                    </div> -->
                  <ActivityBar class="activity-bar" :data="activityInfo" />
                  <div class="c-title">营养师精选闹钟</div>
                  <div class="c-desc"
                    >专业搭配的明星同款闹钟计划，最大化效率方案，一键轻松开启</div
                  >
                </div>
                <div
                  class="recommend-plan-list"
                  v-pageBuried
                  data-page-buried="BG_JIHUALIEBIAO_JINGXUAN"
                >
                  <TemplatePlanItem
                    class="recommend-item"
                    v-for="(item, index) in recommendPlan"
                    :key="index"
                    :data="item"
                  />
                </div>
              </div>
            </van-list>
            <div class="not-more" v-if="finished"
              >- 更多明星同款补剂计划敬请期待 -</div
            >
          </div>
        </div>
      </div>
    </div>

    <CommonToast
      v-model="showCommonToast"
      :options="commonToastData"
      @confirm="bindDefaultConfirm"
      @cancel="bindDefaultCancel"
    />
  </div>
</template>

<script>
import AppNavBar from '@/components/app/nav-bar/index.vue'
import CustomPlanItem from './custom-plan-item.vue'
import TemplatePlanItem from './template-plan-item.vue'
import CommonToast from './common-toast.vue'
import ActivityBar from './activity-bar.vue'
export default {
  components: {
    CustomPlanItem,
    TemplatePlanItem,
    AppNavBar,
    CommonToast,
    ActivityBar
  },
  props: {},
  data() {
    return {
      config: null,
      loaded: false,
      options: { barBackgroundColor: 'rgba(0,0,0,0)' },
      haveCustomOptions: {},
      customPlan: [],
      showCustom: false,
      recommendPlan: [],
      showCommonToast: false,
      commonToastData: null,
      loading: false,
      finished: false,
      page: 1,
      active: 0,
      activityInfo: null
    }
  },
  computed: {
    placeholder() {
      return !!this.customPlan.length
    },
    title() {
      return this.customPlan.length ? '我的营养计划' : ''
    }
  },
  activated() {
    if (this.loaded) {
      this.init()
    }
  },
  created() {
    this.getConfig()
    this.init()
  },
  mounted() {
    this.addScrollEvent()
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    init() {
      this.page = 1
      this.finished = false
      this.recommendPlan = []
      this.getCustomPlanList()
      this.getTemplatePlanList()
      this.loaded = true
    },
    bindRendered(name, title) {
      if (name == 1) {
        this.showCustom = true
      }
    },
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let scrollTop =
        e.target.documentElement.scrollTop ||
        e.target.body.scrollTop ||
        e.target.pageYOffset ||
        0
      if (scrollTop <= 100) {
        this.options = {
          barBackgroundColor: 'rgba(255,255,255,0)'
        }
      } else {
        this.options = {
          barBackgroundColor: 'rgba(255, 255, 255, 1)',
          color: 'rgba(0,0,0.8)'
        }
      }
    },
    bindTopConsult() {
      let url = this.config.expert_incoming_line.route
      this.$betterwe.jumpRoute(url)
    },
    bindConsult() {
      let url = this.config.index_incoming_line.route
      this.$betterwe.jumpRoute(url)
    },
    /* 删除自定义计划 */
    bindDeleteCustomPlan(data) {
      this.commonToastData = {
        title: '删除计划',
        message: '您确定要删除该自定义计划吗？',
        confirmButtonText: '确认删除'
      }
      this.curCurstomPlan = data
      this.bindDefaultConfirm = this.bindDeleteCustomPlanConfirm
      this.showCommonToast = true
    },
    bindDeleteCustomPlanConfirm() {
      this.showCommonToast = false
      this.deleteCustomPlan()
    },
    /* 删除自定义计划 */
    async deleteCustomPlan() {
      let data = this.curCurstomPlan
      let params = {
        plan_id: data.id
      }
      let res = await this.$http
        .postBaseApp('api/v1/TonicPlanOperate/delPlan', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.$toast('删除成功')
          this.getCustomPlanList()
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindDefaultConfirm() {
      this.showCommonToast = false
    },
    bindDefaultCancel() {
      this.showCommonToast = false
    },
    bindAddPlan() {
      this.$router.push({
        path: '/nutrition-clock/select'
      })
    },
    async getConfig() {
      let res = await this.$http
        .getBaseApp('api/v1/TonicShow/config', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.config = res.data
          this.activityInfo = res.data.activity_config
        }
      }
    },
    dealData(data) {
      data.map((item) => {
        if (item && Array.isArray(item.efficacies)) {
          item.efficacies = item.efficacies.slice(0, 3)
        }
      })
      return data
    },
    /* 获取自定义计划列表 */
    async getCustomPlanList() {
      let res = await this.$http
        .postBaseApp('api/v1/TonicShow/getMyPlan', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.customPlan = this.dealData(res.data)
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getTemplatePlanList() {
      let params = {
        page: this.page
      }
      let res = await this.$http
        .getBaseApp('api/v1/TonicShow/getRecommendTemplatePlan', params)
        .catch(() => {
          this.finished = true
        })
      this.loading = false
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.finished = true
          this.page++
          if (res.data.length) {
            this.recommendPlan = this.recommendPlan.concat(
              this.dealData(res.data)
            )
          } else {
            this.finished = true
          }
        } else {
          this.$toast(res.msg)
        }
      }
    },
    async getPlanList() {
      let params1 = {}
      let params2 = {
        page: this.page
      }
      let promise1 = this.$http.getBaseApp(
        'api/v1/TonicShow/getMyPlan',
        params1
      )
      let promise2 = this.$http.getBaseApp(
        'api/v1/TonicShow/getRecommendTemplatePlan',
        params2
      )
      let res = await Promise.all([promise1, promise2]).catch(() => {})
      if (res) {
        let res1 = res[0].data
        let res2 = res[1].data
        if (res1.code == 200 && res2.code == 200) {
          this.customPlan = res1.data
          this.recommendPlan = res2.data
        } else {
          this.$toast(res1.msg || res2.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.consult-icon {
  width: 42px;
  height: 32px;
  object-fit: cover;
}

.plan {
  color: rgba(0, 0, 0, 0.8);
  background: rgba(249, 249, 249, 1);

  .my-tabs {
    ::v-deep .van-tab {
      padding: 0px 15px;
      flex: 0 0 auto;
      font-weight: bold;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.5);
      line-height: 20px;
    }

    ::v-deep .van-tab--active {
      font-weight: bold;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.8);
    }

    ::v-deep .van-tabs__line {
      width: 16px;
      height: 3px;
      background: #03d4e6;
      border-radius: 2px;
    }
  }

  .wrapper {
    height: 100vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .not-custom-plan {
    overflow: hidden;
    background: linear-gradient(121deg, #93d7fa 0%, #b1f3e2 100%);
    padding: 0px 16px 2px;
    background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c2af51444617e541a348095303d5a25e.png');
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center top;
    .activity-bar {
      margin-bottom: 16px;
    }
    .add-btn {
      margin-top: 154px;
      height: 65px;
      box-sizing: border-box;
      background: linear-gradient(0deg, #ffffff 0%, #e8ffff 100%);
      border-radius: 33px;
      border: 1px solid #ffffff;
      font-family: MiSans, MiSans;
      font-weight: bold;
      font-size: 17px;
      color: rgba(0, 0, 0, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 16px;
      .iconfont {
        margin-left: 11px;
        width: 21px;
        height: 21px;
        border-radius: 50%;
        overflow: hidden;
        background: linear-gradient(313deg, #84f5db 0%, #03d4e6 100%);
        display: flex;
        align-items: center;
        justify-content: center;
        color: #fff;
      }
    }

    .consult {
      margin-top: 21px;
      margin-bottom: 16px;
      height: 30px;
      border-radius: 15px;
      background: #fff;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: rgba(0, 0, 0, 0.5);
      padding: 0px 10px 0px 4px;

      .c-text {
        flex: 1;
        flex-shrink: 0;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .c-avatar {
        transform: translateY(-3px);
        width: 26px;
        height: 34px;
        object-fit: cover;
        margin-right: 7px;
      }

      .c-jump {
        font-family: PingFangSC, PingFang SC;
        font-weight: bold;
        font-size: 11px;
        color: #00cddf;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    .c-title {
      font-weight: bold;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.8);
      line-height: 22px;
      margin-bottom: 4px;
    }

    .c-desc {
      font-size: 10px;
      color: rgba(0, 0, 0, 0.5);
      line-height: 14px;
    }
  }

  .plan-content {
    box-sizing: border-box;
    flex: 1;
    flex-shrink: 0;
    overflow: hidden;
  }

  .plan-custom {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: stretch;
  }

  .plan-recommend {
    height: 100%;
    overflow-y: scroll;
  }

  .plan-scroll {
    flex: 1;
    flex-shrink: 0;
    overflow: scroll;
  }

  .custom-plan {
    padding: 0px 16px 0px;
    margin-bottom: 40px;

    .activity-bar {
      margin-top: 10px;
    }

    .custom-list {
      padding: 10px 0px;

      .custom-item {
        margin-bottom: 10px;
      }

      .custom-item:last-child {
        margin-bottom: 0px;
      }
    }

    .add-wrapper {
      height: 137px;
      border-radius: 8px;
      border: 2px dashed #bbbbbb;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  .recommend-title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    line-height: 20px;
    margin-bottom: 16px;

    .item-title {
      margin: 0 12px;
    }

    .item-line {
      width: 70px;
      height: 20px;
    }
  }

  .recommend-plan-container {
    overflow: hidden;
    .activity-bar {
      margin-top: 10px;
    }
  }

  .recommend-plan {
    .recommend-plan-list {
      padding: 10px 16px;

      .recommend-item {
        margin-bottom: 10px;
      }

      .recommend-item:last-child {
        margin-bottom: 0px;
      }
    }

    .not-more {
      margin-top: 18px;
      margin-bottom: 10px;
      text-align: center;
      font-size: 10px;
      font-family: PingFangSC, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 14px;
    }
  }

  .add-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 20px;
    box-sizing: border-box;
    @include paddingBottom(6px);

    .add-btn {
      text-align: center;
      width: 100%;
      height: 58px;
      line-height: 58px;
      background: linear-gradient(
        270deg,
        #6dfdc7 0%,
        #3edcf3 17%,
        #3cb6ff 100%
      );
      box-shadow: 0px 2px 4px 0px rgba(11, 143, 194, 0.1);
      border-radius: 31px;
      font-size: 18px;
      font-family: PingFangSC, PingFang SC;
      font-weight: bold;
      color: #ffffff;
      text-shadow: 0px 2px 4px rgba(11, 143, 194, 0.1);

      .iconfont {
        margin-right: 10px;
      }
    }
  }
}
</style>
